var React = require('react');

function LoaderInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Final","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Landing--inputActive-Copy","transform":"translate(-447.000000, -43.000000)","stroke":"#000000","strokeWidth":"2"},React.createElement("path",{"d":"M460,68 C461.95202,68 463.795181,67.533917 465.424267,66.7069666 C467.92628,65.4369041 469.923333,63.3156274 471.034257,60.7243049 C471.655831,59.274431 472,57.677408 472,56 C472,49.372583 466.627417,44 460,44 C453.372583,44 448,49.372583 448,56","id":"Oval"})))]);
}

LoaderInline.defaultProps = {"width":"26px","height":"26px","viewBox":"0 0 26 26","version":"1.1"};

module.exports = LoaderInline;

LoaderInline.default = LoaderInline;
